import { render } from "./DBLinkedDataView.vue?vue&type=template&id=58bf50f0&scoped=true&ts=true"
import script from "./DBLinkedDataView.vue?vue&type=script&lang=ts"
export * from "./DBLinkedDataView.vue?vue&type=script&lang=ts"

import "./DBLinkedDataView.vue?vue&type=style&index=0&id=58bf50f0&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bf50f0"]])

export default __exports__